import { DataDisplay } from '@/components/show/data-display';
import useInvoice from '@/modules/invoice/application/invoice';
import { convertNumberToCurrency } from '@/utility/helper/common';
import dayjs from 'dayjs';
import {
  Table,
  TableCell,
  TableHead,
  TableRow,
  useSnackbar,
} from '@rrexpress/core';
import { useEffect, useState } from 'react';
import { TableBody } from '@rrexpress/core';
import { IInvoiceAwb, ISummary } from '@/modules/invoice/model/invoice';

const InvoiceReceiptTable: React.FC<{ record: any }> = ({ record }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [summaryData, setSummaryData] = useState<ISummary>();
  const [awbDatas, setAwbDatas] = useState([]);

  const { getSummaryById, getDetailAwb } = useInvoice();
  const { show } = useSnackbar();

  function getDetailSummary() {
    setIsLoading(true);
    getSummaryById(record?.data?.invoice_id as string)
      .then((res) => {
        setSummaryData(res?.data);
      })
      .catch((res) => {
        show(res?.err, 'error');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  function getDetailInvoiceAwb() {
    setIsLoading(true);
    getDetailAwb(record?.data?.invoice_id as string)
      .then((res) => {
        setAwbDatas(res?.data);
      })
      .catch((res) => {
        show(res?.err, 'error');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    getDetailSummary();
    getDetailInvoiceAwb();
  }, []);

  return (
    <>
      {isLoading
        ? ''
        : <div className="relative">
          <div className="mb-4">
            <div className="grid grid-cols-2 gap-x-8 mb-6">
              <div className="flex flex-col gap-y-4 mb-8">
                <DataDisplay
                  label="Customer"
                  value={record?.data?.customer_name}
                />
                <DataDisplay
                  label="No Invoice"
                  value={record?.data.invoice_number}
                />
                <DataDisplay
                  label="Periode"
                  value={`${dayjs(record?.data?.invoice_period_start_date).format('DD MMMM YYYY')} - ${dayjs(record?.data?.invoice_period_end_date).format('DD MMMM YYYY')}`}
                />

              </div>
              <div className="flex flex-col gap-y-4 mb-8">
                <DataDisplay
                  label="Total Berat"
                  value={convertNumberToCurrency(summaryData?.total_weight as number)}
                />
                <DataDisplay
                  label="Total Ongkir"
                  value={convertNumberToCurrency(summaryData?.total_shipping_price as number)}
                />
                <DataDisplay
                  label="Total Diskon"
                  value={convertNumberToCurrency(summaryData?.total_discount_amount as number)}
                />
                <DataDisplay
                  label="Total Asuransi"
                  value={convertNumberToCurrency(summaryData?.total_insurance_fee as number)}
                />
                <DataDisplay
                  label="Total Invoice"
                  value={convertNumberToCurrency(summaryData?.total_price as number)}
                />
              </div>
            </div>
          </div>

          <div className="mb-8 overflow-auto max-h-80">
            <Table className="!table w-full">
              <TableHead>
                <TableRow>
                  <TableCell>Resi</TableCell>
                  <TableCell>Asal</TableCell>
                  <TableCell>Tujuan</TableCell>
                  <TableCell>Layanan</TableCell>
                  <TableCell>Berat</TableCell>
                  <TableCell>Ongkir</TableCell>
                  <TableCell>Diskon %</TableCell>
                  <TableCell>Diskon Rp</TableCell>
                  <TableCell>Asuransi</TableCell>
                  <TableCell>Total</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {awbDatas?.map?.((item: IInvoiceAwb, index: number) => (
                  <TableRow key={index}>
                    <TableCell>{item?.awb_number}</TableCell>
                    <TableCell>{item?.origin_name}</TableCell>
                    <TableCell>{item?.destination_name}</TableCell>
                    <TableCell>{item?.product_service_name}</TableCell>
                    <TableCell>{item?.parcel_weight} Kg</TableCell>
                    <TableCell>
                      <div className="text-right">
                        {convertNumberToCurrency(item?.shipping_price as number)}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="text-right">
                        {item?.discount_perc}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="text-right">
                        {convertNumberToCurrency(item?.discount_amount as number)}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="text-right">
                        {convertNumberToCurrency(item?.insurance_fee as number)}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="text-right">
                        {convertNumberToCurrency(item?.total_price as number)}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </div>
      }
    </>
  );
};

export default InvoiceReceiptTable;
